import { createBootstrap } from "../../bootstrap";

export default createBootstrap("dualApprovals");
